import { GAMAds } from '@/components/GAMAds';
import { HTL_SLOTS } from '@/constants';
import { SlotNames } from '../SearchResults';

export const useSearchAdConfig = (isEnabled: boolean) => {
  if (!isEnabled) return undefined;

  return {
    adPositions: [1, 6, 11],
    slotNames: [
      HTL_SLOTS.SEO_DIRECTORY_INLINE_1,
      HTL_SLOTS.SEO_DIRECTORY_INLINE_2,
      HTL_SLOTS.SEO_DIRECTORY_INLINE_3,
    ],
    render: (slotName: SlotNames) => <GAMAds key={slotName} slotName={slotName} />,
  };
};
